import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const BASE_URL = BACKEND_URL;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export default api;
